<template>
    <div class="template-card" @click="onClick" :class="{ selected }">
        <div class="first">
            <span class="slug">{{ formatedTemplate.name }}</span>
            <div class="actions">
                <a-popconfirm placement="topRight" :ok-text="$t('whatsapp.yes')" :cancel-text="$t('whatsapp.no')" @confirm="deleteAction">
                    <template slot="title"> {{ $t("whatsapp_business_api.sureDeleteTemplate") }}</template>
                    <IconButton>
                        <a-icon type="delete" />
                    </IconButton>
                </a-popconfirm>

                <IconButton>
                    <a-icon type="eye" />
                </IconButton>
            </div>
        </div>
        <div class="second">
            <div class="headers">
                <span>{{ $t("whatsapp_business_api.templateInfo") }}</span>
                <span>{{ $t("wp.description") }}</span>
                <span>{{ $t("message.status") }}</span>
                <span></span>
            </div>
            <div class="cells">
                <div class="cell cell1">
                    <div class="info-item">
                        <label>{{ $t("whatsapp_business_api.category") }} :</label> <span>{{ formatedTemplate.category }}</span>
                    </div>
                    <div class="info-item">
                        <label>{{ $t("settings.language") }} :</label> <span>{{ formatedTemplate.language }}</span>
                    </div>
                    <div class="info-item">
                        <label>{{ $t("message.type") }} :</label> <span>{{ formatedTemplate.type }}</span>
                    </div>
                    <div class="info-item">
                        <label>ID:</label> <span>{{ formatedTemplate.id }}</span>
                    </div>
                </div>
                <div class="cell cell2">
                    <span>
                        {{ formatedTemplate.data }}
                    </span>
                </div>
                <div class="cell cell3">
                    <span
                        v-if="['FAILED', 'REJECTED'].includes(formatedTemplate.status)"
                        v-tippy="{ followCursor: true, placement: 'bottom-end' }"
                        :content="formatedTemplate.reason"
                    >
                        🔴 {{ $t("whatsapp_business_api.rejectWhatsapp") }}
                    </span>
                    <span v-else-if="formatedTemplate.status === 'PENDING'"
                        >🟡 {{ $t("whatsapp_business_api.pendingWhatsapp") }}
                    </span>
                    <span v-else>🟢 {{ $t("whatsapp_business_api.approvedWhatsapp") }}</span>
                </div>
                <div class="cell cell4"></div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import IconButton from "../../Settings/components/IconButton.vue";

export default Vue.extend({
    name: "TemplateCard",
    components: { IconButton },
    props: {
        template: {
            required: true,
        },
        onClick: {
            type: Function,
            default: () => {},
        },
        selected: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        formatedTemplate(){
            const isMetaFormat = this.template.format === "meta";
            return {
                id: this.template.id,
                name: isMetaFormat ? this.template.name : this.template.elementName,
                category: this.template.category,
                language: isMetaFormat ? this.template.language : this.template.languageCode,
                type: isMetaFormat ? this.template.templateType : this.template.templateType,
                status: this.template.status,
                data: isMetaFormat ? this.template.components.find((c) => c.type === "BODY")?.text : this.template.data,
                reason: isMetaFormat ? this.template.rejected_reason : this.template.reason,
            }
        }
    },
    methods: {
        deleteAction(e) {
            this.$emit("deleteTemplate", this.template);
            e.stopPropagation();
        },
    },
});
</script>

<style scoped lang="scss">
.template-card {
    display: flex;
    flex-direction: column;
    gap: 5px;
    border: 1px solid var(--color-border-default);
    padding: 10px;
    max-width: 1000px;
    cursor: pointer;
    border-left: 5px solid transparent;

    &.selected {
        border-left: 5px solid var(--color-border-info-default);
        background: #eeeeee;
    }

    .first {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .slug {
            font-size: 18px;
            font-weight: 700;
            text-decoration: underline;
            color: var(--color-text-info-default);
        }

        .actions {
            display: flex;
            gap: 5px;
        }
    }

    .second {
        display: flex;
        flex-direction: column;
        gap: 5px;

        .headers {
            display: flex;
            justify-content: space-between;
            border-bottom: 1px solid var(--color-border-default);

            span {
                font-weight: 700;
            }

            span:nth-child(1) {
                flex: 1 1 30%;
            }

            span:nth-child(2) {
                flex: 1 1 50%;
            }

            span:nth-child(3) {
                flex: 1 1 20%;
            }

            span:nth-child(4) {
                flex: 1 1 0%;
            }
        }

        .cells {
            display: flex;
            justify-content: space-between;

            .cell1 {
                display: flex;
                flex-direction: column;
                gap: 5px;
                flex: 1 1 30%;

                label {
                    font-weight: 700;
                }
            }

            .cell2 {
                text-align: left;
                flex: 1 1 50%;
                overflow: auto;
            }

            .cell3 {
                flex: 1 1 20%;
            }

            .cell4 {
                flex: 1 1 0%;
            }
        }
    }
}
</style>
